/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useState } from "react";
import { useSelector } from "react-redux";
import { initalRfFeedToRim } from "./types";
import { OPERATIONTYPES } from "../../../globals/constants";
import { selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { useSetDeviceConfigMutation } from "../../../store/api/deviceConfig/deviceConfigApiSlice";
import { useStoreDispatch } from "../../../store/hooks";
import { setBasicDialogOpenFor, setOpenToast } from "../../../store/helpers/helperReducers";
import { prepareconnectRfFeedPayload } from "../helpers";
import { isValidDigit } from "../../../utils/validations";
import { radioUnitIndexesSelector } from "../../../store/api/deviceConfig/selectors";
import { errorMessage } from "../../../utils/helpers";

interface IPayload {
  [key: string]: string;
}

export const useConnectRFFeed = () => {
  const dispatch = useStoreDispatch();

  const [anchorElIP, setAnchorElIP] = useState<null | HTMLElement>(null);
  const [rfFeedToRim, setRfFeedToRim] = useState(initalRfFeedToRim);
  const selectedDevice = useSelector(selectedDeviceSelector);
  const [setDeviceConfig, configStatus] = useSetDeviceConfigMutation();
  const [errMsg, setErrMsg] = useState<IPayload>({});
  const radioUnitIndexes = useSelector(radioUnitIndexesSelector);
  const onblurHandler = (event: any) => {
    const { name, value } = event.target;

    if ((name === "radioUnitIndex" && !isValidDigit(value)) || !radioUnitIndexes.includes(value)) {
      setErrMsg({ ...errMsg, [name]: `Invalid index number.` });
      return;
    }

    setRfFeedToRim({ ...rfFeedToRim });
  };

  const submitHandler = async () => {
    if (!!rfFeedToRim) {
      if (Object.keys(rfFeedToRim).length <= 0) {
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: "Please fill the required fields!" }));
        return;
      }

      const connectRfFeed =
        !!rfFeedToRim && !!selectedDevice?.objectKey && prepareconnectRfFeedPayload(rfFeedToRim, selectedDevice?.objectKey, OPERATIONTYPES.UPDATE);

      try {
        let result: any;

        result = await setDeviceConfig(connectRfFeed);
        if (result?.error || configStatus?.isError) throw result?.error;
        if (result.data?.status === 200) {
          dispatch(setBasicDialogOpenFor(undefined));
          setAnchorElIP(null);
          dispatch(
            setOpenToast({
              openToast: true,
              toastType: "success",
              message: `The data has been submited`,
            })
          );
        }
      } catch (error: any) {
        dispatch(setBasicDialogOpenFor(undefined));
        setAnchorElIP(null);
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
      }
    }
  };

  const deleteRFFeedHandler = () => {};

  return {
    submitHandler,
    anchorElIP,
    setAnchorElIP,
    rfFeedToRim,
    setRfFeedToRim,
    deleteRFFeedHandler,
    onblurHandler,
    errMsg,
    setErrMsg,
  };
};
